<template>
  <div></div>
</template>
<script src="js/main.js"></script>
<script src="js/MovingMarker.js"></script>
<script src="http://code.jquery.com/jquery-1.11.0.js"></script>
<script src="http://code.jquery.com/ui/1.10.3/jquery-ui.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/vis/3.12.0/vis.min.js"></script>
<script src="http://cdn.leafletjs.com/leaflet-0.7.3/leaflet-src.js"></script>
<script>
  import "leaflet/dist/leaflet.css";
  import L from "leaflet";
  import { getTypeIcon, removeEntityFromMap, renderEntityOnMap,renderEntityOnMapHistorial } from "./MapFunctions";
  import LMovingMarker from "vue2-leaflet-movingmarker/index.vue";
  import "vue2-leaflet-movingmarker/dist/MovingMarker";
  import "leaflet.marker.slideto";
  export default {
    props: {
      map: { type: Object, required: true }, // Mapa Leaflet
      positions: { type: [Array, Object], required: false }, // Lista de posiciones [lat, lng]
      statics: { type: [Array, Object], required: false }, // Lista de posiciones estáticas [lat, lng]
      speedOptions: { type: Array, default: () => [500, 1000, 2000] }, // Velocidades en ms
    },
    components: {
      LMovingMarker,
    },
    emits: ["leafletControl"],
    data() {
      return {
        marker: null,
        index: 0,
        isPlaying: false,
        speed: 0,
        intervalId: null,
        isShowRoute: true,
        isViewEnd: true,
        isViewStart: true,
        isViewParking: false,
        gpsRoute: null,
        posicionesProyeccion: null,

        actor: null,
        latlngs: [],
        latlngStatics: [],
        speedArr: [],
        properties: [],
        startPosition: {},
        endPosition: {},
        tooltip: '',
        speedLevel: 1,

        currentIndex: 0, // Se agrego esta linea 
        markers: [],

        currentRouteIndex: 0,

        startIndex:0,

        playerControl: null,
      };
    },
    watch:{
      markers: {
        handler(newValues) {
          // console.log("Markers", newValues);
          // this.$emit('leafletMarkers', newValues);
        },
        deep: true,
      }
    },
    mounted() {
      console.log("Mounted VideoPlayer");
      this.initMap();
    },

    beforeDestroy() {
      // 1. DETENER EL MOVIMIENTO
      // Si usas setInterval:
      if (this.interval) { 
        clearInterval(this.interval); 
      }
      // Si usas una bandera lógica:
      this.isPlaying = false;

      // 2. Remover el control del mapa físicamente
      if (this.playerControl && this.map) {
        this.map.removeControl(this.playerControl);
      }
    },
    
    methods: {
      initMap() {
        // Agregar controles personalizados
        this.addCustomControls();

        // Renderizacion de la ruta del dispositivo
        this.renderContent();
        
        // Crear marcador inicial
        // this.marker = L.marker(this.positions[0]).addTo(this.map);
      },
      

      addCustomControls() {
        this.playerControl = L.control({ position: "bottomleft" }); // O 'bottomright' ajustado
        this.playerControl.onAdd = () => {
          const container = L.DomUtil.create("div", "custom-player-bar");
          
          container.innerHTML = `
            <div class="timeline-wrapper">
              <input type="range" id="playback-slider" min="0" max="${this.latlngs.length - 1}" step="1" value="0" />
              <span id="time-info">${this.currentRouteIndex + 1} / ${this.latlngs.length}</span>
            </div>
            <div class="controls-wrapper">
              <button id="start-route">${this.getButtonIcon('inicio')}</button>
              <button id="prev-pos">${this.getButtonIcon('pasoAtras')}</button>
              <button id="play-btn">${this.getButtonIcon('reproducir')}</button>
              <button id="next-pos">${this.getButtonIcon('pasoAdelante')}</button>
              <button id="end-route">${this.getButtonIcon('final')}</button>
              <button id="speed-select"></button>
              <div id="separator"></div>
              <button id="route-btn">${this.getButtonIcon('recorrido')}</button>
              <button id="end-marker-btn">${this.getButtonIcon('iconoFinal')}</button>
              <button id="start-marker-btn">${this.getButtonIcon('iconoInicio')}</button>
              <button id="static-marker-btn">${this.getButtonIcon('ocultar-estatico')}</button>
            </div>
          `;

          // Eventos (Asumiendo que tus métodos siguen igual)
          //L.DomEvent.disableClickPropagation(container); // Evita que clicks en la barra muevan el mapa
          const slider = container.querySelector("#playback-slider");
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.disableScrollPropagation(container);
          L.DomEvent.on(slider, 'mousedown', (e) => {
            L.DomEvent.stopPropagation(e); // Libera el clic para el slider
          });

          slider.addEventListener("input", (e) => {
            console.log("Slider movido a:", e.target.value);
            this.currentRouteIndex = parseInt(e.target.value);
            this.manualSeek();
          });

          L.DomEvent.on(container.querySelector("#start-route"), "click", this.goToStart, this);
          L.DomEvent.on(container.querySelector("#play-btn"), "click", this.togglePlayPause, this);
          L.DomEvent.on(container.querySelector("#end-route"), "click", this.goToEnd, this);
          L.DomEvent.on(container.querySelector("#speed-select"), "click", this.toggleSpeed, this);
          L.DomEvent.on(container.querySelector("#route-btn"), "click", this.toggleStateRoute, this);
          L.DomEvent.on(container.querySelector("#end-marker-btn"), "click", this.toggleEndRoute, this);
          L.DomEvent.on(container.querySelector("#start-marker-btn"), "click", this.toggleStartRoute, this);
          L.DomEvent.on(container.querySelector("#static-marker-btn"), "click", this.toggleStaticPositions, this);
          //Eventos step posicion por posicion
          L.DomEvent.on(container.querySelector("#prev-pos"), "click", this.prevPosition, this);
          L.DomEvent.on(container.querySelector("#next-pos"), "click", this.nextPosition, this);
          
          return container;
        };
        this.playerControl.addTo(this.map);
        //this.$emit("leafletControl", control);
      },

      renderContent(){
        
        this.renderRoutes();
        // Asignaciones de valores globales
        this.configureInitialData();

        // Se renderiza el marcador de inicio del trayecto
        this.renderStartPosition();

        //Se renderiza el marcador final del trayecto
        this.renderEndPosition();


        // Se renderiza el actor principal
        this.renderActor();
        
        const popup = this.getPopup(this.latlngs[0], this.startPosition.properties);
        this.actor.bindPopup(popup).openPopup();

        //Se renderizan las posiciones estáticas
        // this.renderStaticPositions();
        
        
      },
      renderRoutes(){
        this.gpsRoute = L.geoJSON(this.positions);
        this.gpsRoute.addTo(this.map);
        this.markers.push(this.gpsRoute);
        this.$emit('leafletMarkers', this.markers);
      },
      configureInitialData(){
        const coordinates = this.positions.geometry.coordinates;
        const totalPositions = this.positions.geometry.coordinates.length;
        this.properties = this.positions.properties;
        this.speed = this.calculateSpeed(totalPositions);
        this.setSpeedIconButton(this.speed);
        for (const latlng of coordinates) {
          this.latlngs.push([latlng[1], latlng[0]]);
          this.speedArr.push(this.speed);
        }

        this.startPosition = this.getDataModel(this.latlngs[0], this.properties[0]);
        this.endPosition = this.getDataModel(this.latlngs[totalPositions -1], this.properties[totalPositions -1], true);

        this.$nextTick(() => {
          const slider = document.getElementById("playback-slider");
          if (slider) {
            slider.max = this.latlngs.length - 1;
          }
          this.updateSliderValue();

        });
      },
      calculateSpeed(positions){
        if(positions < 60) return 800;
        if(positions < 100) return 500;
        if(positions < 200) return 300;
        if(positions < 300) return 200;
        return 100;
      },
      setSpeedIconButton(speed){
        const button = document.getElementById("speed-select");
        let icon = '';
        if(speed === 800){
          icon = 'acelerar';
          this.tooltip = 'X1';
          this.speedLevel = 1;
        }else if(speed === 500){
          icon = 'x2';
          this.tooltip = 'X2';
          this.speedLevel = 2;
        }else if(speed === 300){
          icon = 'x3';
          this.tooltip = 'X3';
          this.speedLevel = 3;
        }else if(speed === 200){
          icon = 'x4';
          this.tooltip = 'X4';
          this.speedLevel = 4;
        }else{
          icon = 'x5';
          this.tooltip = 'X5';
          this.speedLevel = 5;
        }
        button.innerHTML = this.getButtonIcon(icon);
        button.title = this.tooltip;
      },

      getDataModel(coord, prop, f = false){
        const icon = f ? getTypeIcon('END') : getTypeIcon('START');
        const title = f ? '<b>Final del trayecto</b><br>': '<b>Inicio del trayecto</b><br>';

        const latlng = {lat: coord[0], lng: coord[1]};
        const properties = prop;
        
        
        const marker = {
          latlng: latlng,
          icon: icon,
          popup: `
            ${title}
            <b>${this.$t('Gral.latitud')}:</b> ${latlng.lat}<br>
            <b>${this.$t('Gral.longitud')}:</b> ${latlng.lng}<br>
            <b>Fecha:</b> ${this.formatoFecha(properties.fechaHora)} hrs.`
        }
        return {latlng, properties, marker }
      },
      renderStartPosition(){
        const marker = this.startPosition.marker;
        
        
        this.startPosition.renderMarker = renderEntityOnMapHistorial(marker, marker.popup,false,this.map);
        this.markers.push(this.startPosition.renderMarker);
      },
      renderEndPosition(){
       
        
        const marker = this.endPosition.marker;
        this.endPosition.renderMarker = renderEntityOnMapHistorial(marker,marker.popup,false, this.map);
        
        
        this.markers.push(this.endPosition.renderMarker);
      },
      renderActor(changeSpeed = false, arr = null){
        if (this.actor) {
          this.actor.stop();
          this.map.removeLayer(this.actor);
          // Removemos la referencia del array de markers también
          this.markers = this.markers.filter(m => m !== this.actor);
        }

        const speed = !changeSpeed ? this.speedArr : arr;

        this.actor = L.Marker.movingMarker(this.latlngs, speed, {
          icon: getTypeIcon('MOV'),
          autoPanOnFocus: true,
          autoPan: true,
          autostart: changeSpeed ? true : false,
        }).addTo(this.map);
        this.markers.push(this.actor);
        // this.$emit('leafletMarkers', this.markers);
        this.addEventActor('move');
        if(!changeSpeed)this.map.flyTo(this.latlngs[0], 13);
      },
      


      addEventActor(event) {

        this.actor.off(event);

        this.actor.on(event, (e) => {

          if (event === 'end') {

            this.isPlaying = false;

            const button = document.getElementById("play-btn");
            if (button) {
              button.innerHTML = this.getButtonIcon('reproducir');
              button.title = 'Reiniciar proyección';
            }

            return;
          }

          const relativeIndex = this.actor._currentIndex ?? 0;
          const absoluteIndex = this.startIndex + relativeIndex;
          this.currentRouteIndex = absoluteIndex;

          const latlng = e?.latlng || this.actor.getLatLng();

          const searchRadius = 10;

          let nearestIndex = this.currentRouteIndex;
          let minDistance = Infinity;

          const start = Math.max(0, this.currentRouteIndex - searchRadius);
          const end = Math.min(this.latlngs.length - 1, this.currentRouteIndex + searchRadius);

          for (let i = start; i <= end; i++) {

            const dist = this.map.distance(latlng, this.latlngs[i]);

            if (dist < minDistance) {
              minDistance = dist;
              nearestIndex = i;
            }

          }

          if (nearestIndex !== this.currentRouteIndex) {

            this.currentRouteIndex = nearestIndex;
            this.updateSliderValue();

            // --- ESTO ES LO QUE HACE QUE LA BARRA SE MUEVA ---
            const slider = document.getElementById("playback-slider");
            const timeInfo = document.getElementById("time-info");
            if (slider) slider.value = this.currentRouteIndex;
            if (timeInfo) timeInfo.innerText = `${this.currentRouteIndex + 1} / ${this.latlngs.length} posiciones`;

            const c = this.latlngs[nearestIndex];
            const p = this.properties[nearestIndex];

            const bounds = this.map.getBounds();
            if (!bounds.contains(c)) {
              this.map.panTo(c, { animate: true, duration: 0.25 });
            }

            const popupContent = this.getPopup(c, p);

            if (!this.actor.getPopup()) {
              this.actor.bindPopup(popupContent).openPopup();
            } else {
              this.actor.setPopupContent(popupContent);
            }

          }

        });

      },




      getPopup(latlng, properties) {
        // <b>${this.$t('vMonitoreo.nudos')}:</b> ${Number.parseFloat(properties.knots).toFixed(2)}<br>
        return `
          <b>${this.$t('Gral.latitud')}:</b> ${ Number.parseFloat(latlng[0]).toFixed(7) }<br>
          <b>${this.$t('Gral.longitud')}:</b> ${Number.parseFloat(latlng[1]).toFixed(7)}<br>
          <b>${this.$t('vMonitoreo.velocidad')}:</b> ${Number.parseFloat(properties.velocidad).toFixed(2)} km/h<br>
         
          <b>${this.$t('vMonitoreo.actualizacion')}:</b> ${this.formatoFecha(properties.fechaHora)} hrs.<br>`;
      },
      formatoFecha(hora) {
        let options = {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
        };
        return new Date(hora).toLocaleDateString("es-ES", options);
      },

      goToStart() {
        this.jumpToStep(0);
        this.map.flyTo(this.latlngs[0], 13);
        // Popup
        const popup = this.getPopup(this.latlngs[0], this.properties[0]);
        this.actor.bindPopup(popup).openPopup();
        
      },

      updatePlayButtonIcon(playing) {
        const button = document.getElementById("play-btn");
        if (button) {
          button.innerHTML = playing ? this.getButtonIcon('pausa') : this.getButtonIcon('reproducir');
          button.title = playing ? 'Pausar proyección' : 'Continuar proyección';
        }
      },

      togglePlayPause(){
        this.isPlaying = !this.isPlaying;
        const button = document.getElementById("play-btn");
        button.innerHTML = this.isPlaying ? this.getButtonIcon('pausa') : this.getButtonIcon('reproducir');
        button.title = this.isPlaying ? 'Pausar proyección' : 'Continuar proyección';
        if (this.isPlaying) {
          this.play();
        } else {
          this.pause();
        }
      },


      play() {
        if (!this.actor) return;

        // 1. AUTO-REINICIO SI ESTAMOS AL FINAL
        // Si el índice actual es el último, reiniciamos todo al principio
        if (this.currentRouteIndex >= this.latlngs.length - 1) {
          this.goToStart(); // Reinicia el actor y los estados
          
          // Damos un pequeño respiro para que el DOM se actualice
          setTimeout(() => {
            this.actor.start();
            this.isPlaying = true;
            this.updatePlayButtonIcon(true);
          }, 100);
          return;
        }

        // 1. Si el actor ya está corriendo, no hagas nada
        if (this.actor.isRunning()) return;

        // 2. Si el actor existe pero está pausado, 
        // VERIFICA SI EL ÍNDICE HA CAMBIADO desde la última pausa.
        // Si NO cambió, solo haz .start()
        if (this.startIndex === this.currentRouteIndex) {
          this.actor.start();
          this.isPlaying = true;
          return;
        }

        // 3. Si el índice CAMBIÓ (alguien usó next/prev/slider),
        // entonces SÍ necesitamos recrearlo desde el nuevo punto:
        this.startIndex = this.currentRouteIndex;
        const currentIndex = this.currentRouteIndex;

        const remainingLatlngs = this.latlngs.slice(currentIndex);
        const remainingDurations = new Array(remainingLatlngs.length).fill(this.speed);

        this.map.removeLayer(this.actor);

        this.actor = L.Marker.movingMarker(remainingLatlngs, remainingDurations, {
          icon: getTypeIcon('MOV'),
          autoPanOnFocus: true,
          autoPan: true,
          autostart: true
        }).addTo(this.map);

        this.addEventActor('move');
        this.addEventActor('end');
        this.isPlaying = true;
      },

      pause() {
        if(this.actor.isRunning()) {
          this.actor.pause();
          //const index = this.actor._currentIndex;
          const index = this.currentRouteIndex;
          const c = this.latlngs[index];
          const p = this.properties[index];
          this.map.setView(this.latlngs[index], this.map.getZoom());
          const popup = this.getPopup(c, p);
          setTimeout(() => {
            this.actor.bindPopup(popup).openPopup();
          },100);
        }
        console.log("pause() this.currentRouteIndex:: ",this.currentRouteIndex);
      },

      goToEnd() {
        const lastIdx = this.latlngs.length - 1;
        this.jumpToStep(lastIdx);
        this.map.flyTo(this.latlngs[lastIdx], 13);
        // Popup
        const popup = this.getPopup(this.latlngs[lastIdx], this.properties[lastIdx]);
        this.actor.bindPopup(popup).openPopup();
      },

      toggleSpeed() {
        this.speedLevel++;
        let icon = `x${this.speedLevel}`;
        const button = document.getElementById("speed-select");
        
        if (this.speedLevel > 5) {
          this.speedLevel = 1;
          button.innerHTML = this.getButtonIcon('acelerar');
          button.title = 'X1';
        }else{
          button.innerHTML = this.getButtonIcon(icon);
          button.title = `X${this.speedLevel}`;
        }
        this.updateActorSpeed();
      },

      updateActorSpeed() {
        console.log("this.currentRouteIndex velocidad:: ",this.currentRouteIndex);
        
        if (!this.actor) return;

        // 1. Determinar la nueva velocidad basada en el nivel actual
        let newSpeed = 800;
        if (this.speedLevel === 1) newSpeed = 800;
        else if (this.speedLevel === 2) newSpeed = 500;
        else if (this.speedLevel === 3) newSpeed = 300;
        else if (this.speedLevel === 4) newSpeed = 200;
        else if (this.speedLevel === 5) newSpeed = 100;

        // 2. Guardar el estado actual: ¿estaba reproduciéndose? ¿en qué índice iba?
        const wasPlaying = this.actor.isRunning();
        const currentIndex = this.currentRouteIndex; // Usamos el índice real detectado por addEventActor

        // 3. Detener y limpiar el actor viejo
        this.actor.stop();
        this.map.removeLayer(this.actor);

        // 4. Crear la sub-ruta restante
        // Cortamos nuestro array original desde el punto actual hasta el final
        const remainingLatlngs = this.latlngs.slice(currentIndex);

        // Si no quedan puntos (llegó al final), no recreamos nada
        /*if (remainingLatlngs.length < 2) {
          this.renderActor(); // Re-renderiza al inicio si es necesario
          return;
        }*/

        // 5. Crear el nuevo arreglo de duraciones con la nueva velocidad
        const remainingDurations = new Array(remainingLatlngs.length).fill(newSpeed);

        let isInitializing = true;

        // 6. Re-instanciar el marcador con la nueva configuración
        this.actor = L.Marker.movingMarker(remainingLatlngs, remainingDurations, {
          icon: getTypeIcon('MOV'),
          autoPanOnFocus: true,
          autoPan: true,
        }).addTo(this.map);

        // 7. Sincronizar el índice interno del nuevo marcador
        // Importante: Como 'remainingLatlngs' es un nuevo array, el índice 0 de este 
        // es en realidad el 'currentIndex' del global.
        // Para que el Slider no se resetee a 0, ajustamos la lógica del evento:
        
        this.actor.on('move', (e) => {
          if (isInitializing) return;
          // El nuevo índice es: índice_del_nuevo_actor + punto_donde_empezó
          const relativeIndex = this.actor._currentIndex;
          //const relativeIndex = this.currentRouteIndex;//****************** */ 
          this.currentRouteIndex = currentIndex + relativeIndex;
          this.updateSliderValue();
          
          // Actualizar Popup e información
          const c = this.latlngs[this.currentRouteIndex];
          const p = this.properties[this.currentRouteIndex];
          this.actor.bindPopup(this.getPopup(c, p));
        });

        this.addEventActor('end');

        isInitializing = false;

        // 8. Mantener el estado de reproducción
        if (wasPlaying) {
          this.actor.start();
          const button = document.getElementById("play-btn");
          if (button) {
            button.innerHTML = this.getButtonIcon('pausa');
            button.title = 'Pausar proyección';
          }
        } else {
          // Si estaba pausado, lo movemos visualmente al punto exacto
          this.actor.setLatLng(this.latlngs[currentIndex]);
        }

        console.log("this.currentRouteIndex fin metodo velocidad:: ",this.currentRouteIndex);
      },

      toggleStateRoute(){
        this.isShowRoute ? this.map.removeLayer(this.gpsRoute) : this.gpsRoute.addTo(this.map);
        this.isShowRoute = !this.isShowRoute;
        const button = document.getElementById("route-btn");
        button.innerHTML = this.isShowRoute ? this.getButtonIcon('recorrido') : this.getButtonIcon('recorridoOcultar');
        button.title = this.isShowRoute ? 'Ocultar trayecto' : 'Mostrar trayecto';
      },
      toggleEndRoute(){
        if(this.isViewEnd){
          removeEntityFromMap(this.endPosition.renderMarker,false,this.map);
        }else{
          this.endPosition.renderMarker = renderEntityOnMapHistorial(this.endPosition.marker,null,false,this.map);
          setTimeout(() => {
            this.endPosition.renderMarker.bindPopup(this.endPosition.marker.popup).openPopup();
          },100);
        }
        this.isViewEnd = !this.isViewEnd;
        const button = document.getElementById("end-marker-btn");
        button.innerHTML = this.isViewEnd ? this.getButtonIcon('iconoFinal') : this.getButtonIcon('ocultarIconoFinal');
        button.title = this.isViewEnd ? 'Ocultar posición final' : 'Mostrar posición final';
      },

      toggleStartRoute(){
        if(this.isViewStart){
          removeEntityFromMap(this.startPosition.renderMarker,false,this.map);
        }else{
          this.startPosition.renderMarker = renderEntityOnMapHistorial(this.startPosition.marker,null,false,this.map);
          setTimeout(() => {
            this.startPosition.renderMarker.bindPopup(this.startPosition.marker.popup).openPopup();
          },100);
        }
        this.isViewStart = !this.isViewStart;
        const button = document.getElementById("start-marker-btn");
        button.innerHTML = this.isViewStart ? this.getButtonIcon('iconoInicio') : this.getButtonIcon('ocultarIconoInicio');
        button.title = this.isViewStart ? 'Ocultar posición inicial' : 'Mostrar posición inicial';
      },
      toggleStaticPositions(){
        this.isViewParking = !this.isViewParking;
        let arr = [];
        if(this.isViewParking){
          
          this.statics.forEach(position => {
            const latlng= position.position;
            const data = {
              icon: getTypeIcon('EST'),
              latlng: {lat: latlng.lat, lng: latlng.lng},
            }
            const popup = `
              <b>${this.$t('Gral.latitud')}:</b> ${latlng.lat}<br>
              <b>${this.$t('Gral.longitud')}:</b> ${latlng.lng}<br>
              <b>Tiempo de estadía: </b> ${this.formatoEstadia(position.tiempoEstatico)}<br>
              <b>${this.$t('vMonitoreo.actualizacion')}:</b> ${position.description} hrs.<br>`;
            position.marker = renderEntityOnMapHistorial(data, popup,false,this.map);
            arr.push(position.marker);
          });
          // this.makers.push(arr);
          // this.$emit('leafletMarkers', this.markers);
        }else{
          this.statics.forEach(position => {
            removeEntityFromMap(position.marker,false,this.map);
          });
        }
        const button = document.getElementById("static-marker-btn");
        button.innerHTML = this.isViewParking ? this.getButtonIcon('dispositivo-estatico-redondo') : this.getButtonIcon('ocultar-estatico');
        button.title = this.isViewParking ? 'Ocultar posiciones estáticas' : 'Mostrar posiciones estáticas';
      },
      getButtonIcon(icon){
        return `<img alt="${icon}" src="/assets/img/${icon}.svg" width="20" height="20"/>`;
      },
      
      formatoEstadia(segundos) {
        var segs,
          dias,
          horas,
          min,
          cad = "No aplica";

        segs = segundos;
        if (segs == null || segs <= 60) {
          // si el tiempo de estadía es menor a un minuto o null, No aplica
          return cad;
        } else {
          cad = "";
        }
        if (segs > 86400) {
          //Días
          dias = Math.floor(segs / 86400);
          segs -= dias * 86400;
          cad += dias + " días ";
        }
        if (segs > 3600) {
          //Horas
          horas = Math.floor(segs / 3600);
          segs -= horas * 3600;
          cad += horas + " horas ";
        }
        if (segs > 60) {
          //Minutos
          min = Math.floor(segs / 60);
          segs -= min * 60;
          cad += min + " minutos ";
        }
        if (segs > 0) {
          //Segundos
          cad += segs + " segundos.";
        }
        return cad;
      },

      nextPosition() {
        this.pause(); // Pausamos si está reproduciendo
        let currentIndex = this.currentRouteIndex;
        
        // Si no es el último punto, avanzamos
        if (currentIndex < this.latlngs.length - 1) {
          const nextIdx = currentIndex + 1;
          this.currentRouteIndex = nextIdx;
          this.jumpToStep(nextIdx);
          this.updateSliderValue();
          this.setPausedState();
        }
      },

      prevPosition() {
        this.pause();

        let currentIndex = this.currentRouteIndex;
        if (this.currentRouteIndex > 0) {
          const prevIdx = currentIndex - 1;
          this.currentRouteIndex = prevIdx;
          this.jumpToStep(prevIdx);
          this.updateSliderValue();
          this.setPausedState();
        }
      },

      

      setPausedState() {
        this.isPlaying = false; // Marcamos como pausado internamente
        const button = document.getElementById("play-btn");
        if (button) {
          button.innerHTML = this.getButtonIcon('reproducir');
          button.title = 'Continuar proyección';
        }
      },

      

      jumpToStep(idx) {
        if (!this.latlngs || this.latlngs.length === 0) return;

        // 1. Detener y limpiar el actor actual
        if (this.actor) {
          this.actor.stop();
          this.map.removeLayer(this.actor);
          this.markers = this.markers.filter(m => m !== this.actor);
        }

        // 2. Actualizar índices de estado
        this.currentRouteIndex = idx;
        this.startIndex = idx;
        this.updateSliderValue();

        // 3. Preparar la nueva sub-ruta desde el índice elegido
        const remainingLatlngs = this.latlngs.slice(idx);
        const remainingDurations = new Array(remainingLatlngs.length).fill(this.speed);

        // 4. Crear el nuevo actor con la ruta corregida
        this.actor = L.Marker.movingMarker(remainingLatlngs, remainingDurations, {
          icon: getTypeIcon('MOV'),
          autoPanOnFocus: true,
          autoPan: true,
        }).addTo(this.map);

        this.markers.push(this.actor);
        this.addEventActor('move');
        this.addEventActor('end');

        // 5. Posicionar mapa y Popup
        const newPos = this.latlngs[idx];
        const p = this.properties[idx];
        const popup = this.getPopup(newPos, p);
        
        this.actor.bindPopup(popup).openPopup();

        if (idx === 0) {
          this.map.flyTo(newPos, 13);
        } else {
          this.map.panTo(newPos);
        }

        this.isPlaying = false;
        // Actualizar icono de play
        const button = document.getElementById("play-btn");
        if (button) button.innerHTML = this.getButtonIcon('reproducir');
      },

    
      //Cuando mueves la barra manualmente
      manualSeek() {
        console.log("entro");
        
        this.pause(); // Pausamos la reproducción automática
        this.jumpToStep(this.currentRouteIndex); // Usamos tu función existente
        this.updateSliderValue();
      },

      updateSliderValue() {
        const slider = document.getElementById("playback-slider");
        const timeInfo = document.getElementById("time-info");
        if (slider) {
          slider.value = this.currentRouteIndex;
        }
        if (timeInfo) {
          timeInfo.innerText = `${this.currentRouteIndex + 1} / ${this.latlngs.length} posiciones`;
        }
      },

 
    },//END Methods
  };
</script>

<style>
.leaflet-control-custom {
  background: white;
  padding: 5px;
  display: flex;
  position: absolute !important;
  right: 45px;
  top: 104px;
  gap: 5px;
}

.leaflet-bottom, .leaflet-left{
  width: 100%;
}

.leaflet-control-custom button,
.leaflet-control-custom select {
  border: 2px solid #bbb;
  padding: 5px;
  cursor: pointer;
  border-radius: 3px;
}

.leaflet-control-custom button:hover,
.leaflet-control-custom select:hover {
  background: #F4F4F4;
}

#separator {
  border-left: 4px solid slategrey;
  height: 35px;
  left: 2px;
  right: 2px;
}

.timeline-container {
  position: absolute;
  bottom: 80px;
  /* Ajusta según la posición de tus controles */
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.playback-bar {
  width: 100%;
  cursor: pointer;
  accent-color: #2196F3;
  /* Color de la barra */
}

.time-info {
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
}


.custom-player-bar {
  background: rgba(255, 255, 255, 0.7);
  /* Transparente */
  backdrop-filter: blur(5px);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 50%;
}

.timeline-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

#playback-slider {
  height: 12px;
  /* Grosor de la barra */
  flex-grow: 1;
  cursor: pointer;
  accent-color: #2196F3;
}

.controls-wrapper {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.controls-wrapper button {
  padding: 12px;
  /* Más espacio alrededor del icono */
  font-size: 18px;
  /* Si usas iconos de texto/font-awesome */
  transform: scale(1.2);
  /* Escala visual del icono */
  transition: transform 0.2s;
}

.controls-wrapper button:hover {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.leaflet-left .leaflet-control {
  margin-left: 20% !important;
  margin-bottom: 20px;
}

#separator {
  border-left: 2px solid #ccc;
  height: 40px;
  margin: 0 15px;
}
</style>